import { fetchSyncJobStatuses } from "@/grid/data/fetch-sync-status";
import { useQuery } from "@tanstack/react-query";

export function useSyncStatus() {
  return useQuery({
    queryKey: ["warehouse", "sync-status"],
    queryFn: fetchSyncJobStatuses,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}
